import { useTranslation } from 'react-i18next';
import { useAppStore } from '@/app/appStore';
import { Composer } from './Composer';
import { MessageList } from './MessageList';
import { SuggestedPrompts } from './SuggestedPrompts';
import { useChatStore } from './chatStore';

/**
 * ChatPane renders without any outer sizing — the parent (Shell or a
 * detached window) is responsible for positioning and dimensioning.
 * This keeps the right-rail and footer-drawer layouts identical internally.
 */
export function ChatPane() {
  const { t } = useTranslation('chat');
  const collapsed = useAppStore((s) => s.chatCollapsed);
  const append = useChatStore((s) => s.append);

  if (collapsed) return null;

  function handlePromptPick(prompt: string) {
    append({
      role: 'user',
      content: prompt,
      timestamp: new Date().toISOString(),
    });
  }

  return (
    <aside
      aria-label={t('placeholder')}
      className="flex h-full w-full min-h-0 min-w-0 flex-col bg-card"
      data-testid="chat-pane"
    >
      <div className="flex h-10 items-center justify-between border-b border-border px-3 text-xs font-semibold uppercase text-muted-foreground">
        <span>{t('agent')}</span>
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto">
        <MessageList />
      </div>
      <SuggestedPrompts onPick={handlePromptPick} />
      <Composer />
    </aside>
  );
}
